import { render, staticRenderFns } from "./ContractorsSettingsForm.vue?vue&type=template&id=21e0566f&"
import script from "./ContractorsSettingsForm.vue?vue&type=script&lang=js&"
export * from "./ContractorsSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports